import React, {Component} from 'react';

export const SoldOut = () => {
  return (
    <div> 
      <h5 style={{backgroundColor: '#000', color: '#fff', position: 'absolute', top: '30%', left: '25%', padding: '10px', width:'60%', textAlign: 'center'}}><strong> SOLD OUT </strong></h5>
    </div>
  )
} 



// WEBPACK FOOTER //
// ./src/components/SoldOut.js